import { Component, inject } from '@angular/core';
import { Session } from '../../services/session/session.service';
import { DeferPanelComponent } from '../core/panels/defer-panel.component';
import { AlertsCardComponent } from './alerts-card.component';
import { AnnouncementsCardComponent } from './announcements-card.component';
import { HistoryCardComponent } from './history-card.component';
import { ReportsCardComponent } from './reports-card.component';
import { ResourceHubCardComponent } from './resource-hub-card.component';
import { SearchCardComponent } from './search-card.component';
import { TasksCardComponent } from './tasks-card.component';
import { TipsCardComponent } from './tips-card.component';
import { WatchlistCardComponent } from './watchlist-card.component';

@Component({
  selector: 'app-home-page',
  imports: [
    HistoryCardComponent,
    SearchCardComponent,
    TasksCardComponent,
    AlertsCardComponent,
    WatchlistCardComponent,
    AnnouncementsCardComponent,
    ReportsCardComponent,
    ResourceHubCardComponent,
    TipsCardComponent,
    DeferPanelComponent,
  ],
  template: `
    <div class="tw-flex tw-flex-col xl:tw-flex-row tw-gap-6">
      <div class="tw-w-full tw-min-w-0 lg:tw-basis-1/2">
        <div class="tw-flex tw-flex-col tw-gap-6">
          <app-history-card />
          <app-tasks-card />

          @defer (on viewport) {
            <app-watchlist-card />
          } @placeholder {
            <app-defer-panel height="420px" />
          }

          @if (hasReportsAccess) {
            @defer (on viewport) {
              <app-reports-card />
            } @placeholder {
              <app-defer-panel height="550px" />
            }
          }
        </div>
      </div>
      <div class="tw-w-full tw-min-w-0 lg:tw-basis-1/2">
        <div class="tw-flex tw-flex-col tw-gap-6">
          @if (hasSearchAccess) {
            <app-search-card />
          }
          @if (hasAlertsAccess) {
            <app-alerts-card />
          }

          <div class="tw-w-full tw-min-w-0 tw-overflow-hidden">
            @defer (on viewport) {
              <app-announcements-card />
            } @placeholder {
              <app-defer-panel height="420px" />
            }
          </div>

          <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-8">
            @defer (on viewport) {
              @if (hasResourceHubAccess) {
                <app-resource-hub-card
                  class="tw-flex-1 tw-min-w-0"
                  #resourceHub
                  [class.tw-hidden]="!resourceHub.hasVisibleLinks()"
                />
                <app-tips-card class="tw-flex-1 tw-min-w-0" />
              } @else {
                <app-tips-card class="tw-flex-1 tw-min-w-0" />
              }
            } @placeholder {
              <app-defer-panel height="550px" />
            }
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [``],
})
export class HomePageComponent {
  hasAlertsAccess = false;
  hasReportsAccess = false;
  hasSearchAccess = false;
  hasResourceHubAccess = false;

  constructor() {
    const session = inject(Session);

    const isSpecificClaimUser = session.isSpecificClaimUser;
    this.hasAlertsAccess =
      !isSpecificClaimUser && session.authorize('AlertsModule');
    this.hasReportsAccess =
      !isSpecificClaimUser && session.authorize('ReportsModule');
    this.hasSearchAccess = !isSpecificClaimUser;
    this.hasResourceHubAccess = !isSpecificClaimUser;
  }
}
